import { makeStyles } from '@material-ui/core/styles';

const useStyleNavbar = makeStyles((theme) => ({
    appBar: {
      backgroundColor: "#fff",
    },
    headText: {
      color: "#666",
      float: "left",
    } 
  }));

export default useStyleNavbar;
